import { Button, Layout, Popconfirm, Space, Table, Typography } from "antd";
import { motion } from "framer-motion";
import { useTranslation } from "react-i18next";
import { emailTemplatesTable } from "@configurations";
import { useGetEmailTemplates, useGetLanguages, useResetAllEmailTemplates } from "@hooks";

export const EmailTemplatesPage = () => {
  const { t } = useTranslation();
  const { data, isLoading } = useGetEmailTemplates();
  const { data: languages = [], isLoading: isLanguagesLoading } = useGetLanguages();
  const resetAllEmailTemplates = useResetAllEmailTemplates();
  const languageLookup = languages.reduce<Record<string, string>>((acc, language) => {
    acc[language.id] = language.name;
    return acc;
  }, {});

  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 1 }}
    >
      <Layout>
        <div style={{ display: "flex", marginBottom: 12 }}>
          <div
            style={{
              width: 3,
              backgroundColor: "#F1B80E",
              borderRadius: 100,
              marginRight: 12,
            }}
          />
          <div>
            <Typography.Title level={2} style={{ margin: 0 }}>
              {t("pages.emailTemplates.title")}
            </Typography.Title>
            <Typography.Text type="secondary">
              {t("emailTemplateEditor.description")}
            </Typography.Text>
          </div>
        </div>

        <Space style={{ marginBottom: 16 }}>
          <Popconfirm
            title={t("emailTemplateEditor.resetAllConfirmTitle")}
            description={t("emailTemplateEditor.resetAllConfirmDescription")}
            onConfirm={() => resetAllEmailTemplates.mutate()}
            okText={t("reset")}
            cancelText={t("cancel")}
          >
            <Button loading={resetAllEmailTemplates.isPending}>{t("emailTemplateEditor.resetAll")}</Button>
          </Popconfirm>
        </Space>

        <div
          style={{
            boxShadow: "rgba(0, 0, 0, 0.16) 1px 0px 10px",
            borderRadius: "8px",
            marginTop: 12,
          }}
        >
          <Table
            size="middle"
            dataSource={data}
            rowKey={(record) => `${record.name}-${record.languageId}`}
            loading={isLoading || isLanguagesLoading}
            style={{ borderRadius: "8px" }}
            columns={emailTemplatesTable(t, languageLookup, languages)}
          />
        </div>
      </Layout>
    </motion.div>
  );
};